import { president } from '../pages/Mandat';

function PhotoEquipe() {
  return (
    <div className="relative text-center w-full mx-auto h-[200px] bg-cover overflow-hidden">
      <div className="absolute top-[-25px] left-0 right-0 bottom-0 bg-center bg-no-repeat bg-cover opacity-20" style={{ backgroundImage: "url('/images/banniere.avif')" }}></div>
      <div className="px-6 relative flex items-center justify-center min-h-[200px]">
        <h2 className="font-comme font-bold text-[40px] md:text-[50px] lg:text-[60px] leading-tight text-center text-gris-sombre dark:text-blanc-sombre max-w-4xl w-full">
          Qui sommes-<span className="text-bleu-je">nous</span> ?
        </h2>
      </div>
    </div>
  );
}

function MotDuPresident() {
  const estPresident = president.role && president.role.toLowerCase() === "président";

  return (
    <div className="flex flex-col lg:flex-row items-center justify-center p-5 gap-8 bg-white dark:bg-gris-sombre my-10">

      <div className="relative flex justify-center items-center flex-1 max-w-[300px] lg:max-w-[400px]">
        <img src={`${president.photo}`} alt="Président" className="relative w-[200px] h-auto z-[1]" />
        <img src="../images/fond_bleu.jpg" alt="Fond bleu" className="absolute top-[20px] left-[-18px] lg:top-[20px] lg:left-[84px] h-[98%] opacity-50" />
      </div>

      <div className="flex flex-col items-center flex-1 bg-gris-clair dark:bg-bleu-gris p-5 rounded-lg shadow-md max-w-full lg:max-w-[600px]">
        <h2 className="text-[24px] md:text-[32px] font-comme font-semibold leading-tight text-center text-gris-sombre dark:text-fond-sombre mb-4">
          {estPresident ? (
            <>Le mot du <span className="text-bleu-je dark:text-bleu-sombre">Président</span></>
          ) : (
            <>Le mot de la <span className="text-bleu-je dark:text-bleu-sombre">Présidente</span></>
          )}
        </h2>
        <p className="text-[16px] md:text-[20px] font-comme text-gris-sombre dark:text-fond-sombre leading-relaxed tracking-[0.01em] text-justify">
          Je suis très fier de présider cette équipe dynamique et engagée. Nous travaillons chaque jour pour atteindre nos objectifs et réaliser notre mission avec passion et détermination.
        </p>
      </div>
    </div>
  );
}

export { PhotoEquipe, MotDuPresident };